module.exports = __webpack_public_path__ + "static/media/whatsapp1.1c724e6d.png";